import { getNetwork } from 'app/scripts/services/app-state';
import request from '@host-panel/request';
import { CurrentUserResponse } from '../../../../current-user/currentUserTypes';

export function currentUser(
  spotId: string,
  networkId: string,
  originalNetwork: string = getNetwork().id
): Promise<CurrentUserResponse> {
  return request(`/authentication/cross`, {
    method: 'POST',
    headers: {
      'x-spotim-networkid': networkId,
      'x-spot-id': spotId
    },
    data: {
      original_network: originalNetwork
    },
    addJWTtoLocalStorage: true
  });
}
